import { useAuth } from "./context/AuthContext";
import LoginPage     from "./pages/LoginPage";
import OwnerApp      from "./pages/owner/OwnerApp";
import StudentApp    from "./pages/student/StudentApp";
import InstallBanner from "./components/InstallBanner";
import OfflineBanner from "./components/OfflineBanner";
import { Spinner }   from "./components/UI";

export default function App() {
  const { user, profile, loading } = useAuth();

  if (loading) return (
    <div style={{ display:"flex", height:"100dvh", alignItems:"center", justifyContent:"center", background:"#0d2340" }}>
      <Spinner />
    </div>
  );

  return (
    <>
      <OfflineBanner />
      <InstallBanner />
      {(!user || !profile) && <LoginPage />}
      {user && profile?.role === "owner"   && <OwnerApp   user={user} profile={profile} />}
      {user && profile?.role === "student" && <StudentApp user={user} profile={profile} />}
      {user && profile && !["owner","student"].includes(profile.role) && (
        <div style={{ display:"flex", height:"100dvh", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:12, fontFamily:"sans-serif", background:"#0d2340", color:"white", padding:24, textAlign:"center" }}>
          <p style={{ fontSize:18, fontWeight:700 }}>Profil introuvable</p>
          <p style={{ fontSize:14, opacity:0.7 }}>Vérifiez la collection users dans Firebase Console.</p>
        </div>
      )}
    </>
  );
}
